import React from "react";
import { Box, Typography } from "@mui/material";
import { BackButton } from "../buttons";

const ErrorState = ({
  title,
  message,
  icon = "!",
  iconBackgroundColor = "#FEF2F2",
  iconColor = "#DC2626",
  onBack,
  backDisabled = false,
}) => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 520,
          textAlign: "center",
          p: { xs: 3, sm: 4 },
          border: "1px solid #E6ECEA",
          borderRadius: 3,
          backgroundColor: "#FFFFFF",
          boxShadow: "0 4px 16px rgba(16, 24, 22, 0.06)",
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: "auto",
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            backgroundColor: iconBackgroundColor,
            color: iconColor,
            fontSize: 24,
            fontWeight: 700,
          }}
        >
          {icon}
        </Box>

        <Typography
          variant="h6"
          sx={{
            mb: 1,
            color: "#1F2937",
            fontWeight: 700,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            mb: 3,
            color: "#6B7280",
            fontSize: 14,
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>

        <BackButton onClick={onBack} disabled={backDisabled} />
      </Box>
    </Box>
  );
};

export default ErrorState;
